<div *ngIf="content" class="section-box">
  <h2 class="section-title" i18n="@@currencyDetail.howToBuy.title">How To Buy {{ currencyName }} In {{ fiatCode }}</h2>
  <div class="section-content" [innerHTML]="content | safeHtml"></div>
</div>
